import { useEffect, useState } from 'react';
import fetchData from 'services/fetchData';

const useFetchData = (
  endPoint,
  { defaultData = [], dependency = [], dataModifier, when, isStatic } = {}
  // setLoading = () => {}
) => {
  const [data, setData] = useState(defaultData);
  const [loading, setLoading] = useState(true);

  const fetchRequest = async (cache = 'default') => {
    setLoading(true);
    const response = await fetchData(endPoint, { cache, isStatic });
    if (response.status) {
      const fetchedData = dataModifier
        ? dataModifier(response.data)
        : response.data;
      setData(fetchedData);
    } else {
      console.log('Failed to get data :', response.message);
    }
    setLoading(false);
  };

  const refreshData = () => fetchRequest('reload');

  useEffect(() => {
    if (when) {
      if (when()) {
        fetchRequest();
      }
    } else {
      fetchRequest();
    }
  }, [...dependency]);

  return [data, loading, setData, refreshData];
};

export default useFetchData;
